<template>
  <div :class="['guest-auth', `guest-auth--${variant}`]">
    <SpaInternalLink
      :href="loginHref"
      class="guest-cta guest-cta--login"
      aria-label="ログインページへ移動"
    >
      <span class="guest-cta__pill">
        <LoginHeaderButton />
      </span>
      <span class="guest-cta__icon-nav">
        <img
          :src="loginIcon"
          alt=""
          class="guest-cta__icon"
          width="24"
          height="24"
          aria-hidden="true"
        />
        <span class="guest-cta__label">ログイン</span>
      </span>
    </SpaInternalLink>
    <SpaInternalLink
      :href="signupHref"
      class="guest-cta guest-cta--signup"
      aria-label="新規会員登録ページへ移動"
    >
      <span class="guest-cta__pill">
        <SignupButton>新規会員登録</SignupButton>
      </span>
      <span class="guest-cta__icon-nav">
        <img
          :src="signupIcon"
          alt=""
          class="guest-cta__icon"
          width="24"
          height="24"
          aria-hidden="true"
        />
        <span class="guest-cta__label guest-cta__label--signup">新規会員登録</span>
      </span>
    </SpaInternalLink>
  </div>
</template>

<script setup lang="ts">
import loginIcon from '@/assets/images/header-login.svg';
import signupIcon from '@/assets/images/header-signup.svg';
import LoginHeaderButton from '@/components/shared/button/LoginHeaderButton.vue';
import SignupButton from '@/components/shared/button/SignupButton.vue';
import SpaInternalLink from '@/components/shared/SpaInternalLink.vue';

const loginHref = '/candidate/login';
const signupHref = '/signup/new';

withDefaults(
  defineProps<{
    /**
     * pills: 常にピル型（PC ヘッダー）
     * responsive: SP ヘッダー用。576px 未満はアイコン＋ラベル、576px 以上はピル型
     */
    variant?: 'pills' | 'responsive';
  }>(),
  {
    variant: 'pills',
  }
);
</script>

<style scoped lang="scss">
@import '@/assets/stylesheets/components/_variables.scss';

/** ピル表示時のツールバー（子の display は .guest-auth 基底と sm 時の mixin で揃える） */
@mixin guest-auth-pill-toolbar {
  align-items: center;
  gap: 12px;
}

/** responsive で sm 以上に戻すとき、narrow 時の子要素上書きを解除する */
@mixin guest-auth-pill-children {
  .guest-cta__pill {
    display: block;
  }

  .guest-cta__icon-nav {
    display: none;
  }
}

.guest-auth {
  display: flex;
  flex-shrink: 0;
  min-width: 0;

  .guest-cta__pill {
    display: block;
  }

  .guest-cta__icon-nav {
    display: none;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    gap: 4px;
    padding: 0;
    min-width: 0;
    text-decoration: none;
  }

  .guest-cta__icon {
    width: 24px;
    height: 24px;
    object-fit: contain;
    flex-shrink: 0;
  }

  .guest-cta__label {
    font-size: 10px;
    line-height: 1.4;
    letter-spacing: 0.62px;
    color: #202020;
    white-space: nowrap;
  }

  .guest-cta__label--signup {
    white-space: normal;
    text-align: center;
    max-width: 4.75rem;
    line-height: 1.25;
    font-size: 9px;
    letter-spacing: 0.02em;
  }
}

.guest-auth--pills {
  @include guest-auth-pill-toolbar;
}

.guest-auth--responsive {
  align-items: flex-start;
  gap: 16px;

  .guest-cta__pill {
    display: none;
  }

  .guest-cta__icon-nav {
    display: flex;
  }

  @media (min-width: $layout-sm) {
    @include guest-auth-pill-toolbar;
    @include guest-auth-pill-children;
  }
}

.guest-cta {
  text-decoration: none;
  color: inherit;
  min-width: 0;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
}

.guest-cta:focus-visible {
  outline: 2px solid $primary-blue;
  outline-offset: 2px;
  border-radius: 4px;
}
</style>
